var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditpolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.04,
    height: 29.371,
    viewBox: "0 0 32.04 29.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editpolygon",
    transform: "translate(-524 -311.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(524 318.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.289,2.59a.919.919,0,0,0-.8.459l-6.121,10.6a.924.924,0,0,0,0,.918l6.121,10.6a.919.919,0,0,0,.8.459H20.531a.919.919,0,0,0,.8-.459l6.121-10.6a.924.924,0,0,0,0-.918l-6.121-10.6a.919.919,0,0,0-.8-.459H8.289Z",
    transform: "translate(-1.25 -2.59)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(535.018 311.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Round-_-Image-_-edit",
    "data-name": "-Round-/-Image-/-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H21.022V21.022H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-Color",
    "data-name": "\\uD83D\\uDD39-Icon-Color",
    d: "M3,15.666v2.663a.434.434,0,0,0,.438.438H6.1a.411.411,0,0,0,.307-.131l9.565-9.556L12.688,5.794,3.131,15.35A.43.43,0,0,0,3,15.666ZM18.513,6.538a.872.872,0,0,0,0-1.235l-2.05-2.05a.872.872,0,0,0-1.235,0l-1.6,1.6L16.91,8.141Z",
    transform: "translate(-0.372 -0.372)",
    fill: "#e6e6e6",
    fillRule: "evenodd"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpolygon);
export default __webpack_public_path__ + "static/media/editpolygon.cad12b798815739a56210356fb223e7c.svg";
export { ForwardRef as ReactComponent };